import i18n from '@/i18n'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'
import Layout from '../layout.vue'
import List from './list.vue'

const basePath = '/v-admin/ai-chatbot-config/management'

export default {
  path: basePath,
  redirect: `${basePath}/list`,
  component: Layout,
  meta: {
    isAllInclude: true,
    permission: 'PREMIUM_AI_CHATBOT',
    isNewPage: true,
    titleI18nKey: 'admin.company.aiChatbotConfigManagement.title.index',
    menu: {
      get label () {
        return i18n.t('admin.company.aiChatbotConfigManagement.menu')
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
    }
  },
  children: [
    {
      path: `${basePath}/list`,
      component: List,
      meta: {
        isNewPage: true,
        breadcrumb: { hidden: true },
        titleI18nKey: 'admin.company.aiChatbotConfigManagement.title.index'
      }
    }
  ]
}
